import {mapGetters, mapMutations} from 'vuex'

export const modalMixin = {
  data: () => ({
    modalId: null,
    modalType: null,
    modalField: null,
    modalFieldType: null,
    modalData: null,
    showModal: {
      showUsageStats: false,
      changeStatusToEdited: false,
      approveCreativeDownloads: false,
      assignUsersToClient: false,
      changeAeFile: false,
      deleteClient: false,
      deleteFootage: false,
      deleteUser: false,
      resetUser: false,
      deleteEncodingProfile: false,
      editEncodingProfile: false,
      addEncodingProfile: false,
      cloneEncodingProfile: false,
      assignEncodingProfileToClients: false,
      createCampaign: false,
      editCampaign: false,
      deleteCampaign: false,
      cloneCampaign: false,
      editCreative: false,
      cloneCreative: false,
      deleteCreative: false,
      assetLibrary: false,
      deleteCreativeUnit: false,
      sendToCreative: false,
      copyCreativeUnit: false,
      downloadHistory: false,
      previewLink: false,
      adtagLink: false,
      addUnit: false,
      deleteLink: false,
      editLink: false,
      refreshLink: false,
      deleteTag: false,
      editTag: false,
      refreshTag: false,
      chargeConfirmation: false,
      adtagConfirmation: false,
      chargeSingleConfirmation: false,
      adjustments: false,
      deleteAdjustment: false,
      addAdjustment: false,
      editAdjustment: false,
      generateOverview: false,
      invoiceNumber: false,
      htmlToVideoRenderOptions: false,
      bulkEditUnit: false,
      createPreviewLink: false,
      reviewLinkHistory: false,
      footageLibrary: false,
      creativeAssociate: false,
      editCreativeAssociate: false,
      requestCreativeDownloadApproval: false,
      alterAeCreative: false,
      cancelRendersRequests: false,
      deleteRenderBot: false
    }
  }),
  mounted () {
    document.addEventListener('keydown', (e) => {
      if (this.show && e.keyCode === 27) {
        this.close()
      }
    })
  },
  computed: {
    ...mapGetters({
      'loading': 'modals/loading'
    })
  },
  methods: {
    ...mapMutations({
      'startLoading': 'modals/setStartLoading',
      'finishLoading': 'modals/setFinishLoading'
    }),
    toggleModal (type) {
      this.showModal[type] = !this.showModal[type]
    },
    onLaunchModal (e) {
      this.modalId = e.currentTarget.dataset.modalid
      this.modalType = e.currentTarget.dataset.modaltype
      this.modalField = e.currentTarget.dataset.modalfield
      this.modalFieldType = e.currentTarget.dataset.modalfieldtype
      this.showModal[this.modalType] = true
    },
    triggerModal (e) {
      this.$emit('showModal', e.currentTarget.title, e.currentTarget.dataset.modaltype, e.currentTarget.dataset.confirmid)
    },
    close () {
      this.$emit('close')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/modalMixin.js